<div class="container-fluid">
  <div class="row">
    <div
      [ngClass]="{
        'col-auto': wholeNavIsCollapsed || multiNavIsCollapsed,
        'col-flex-22': !wholeNavIsCollapsed && !multiNavIsCollapsed
      }"
      class="g-0"
    >
      <app-nav
        [(wholeNavIsCollapsed)]="wholeNavIsCollapsed"
        [(multiNavIsCollapsed)]="multiNavIsCollapsed"
        class="min-vh-100 h-100"
      ></app-nav>
    </div>
    <div class="col p-0 position-relative">
      <app-loading-mask maskText="Loading...">
        <router-outlet></router-outlet>
      </app-loading-mask>
    </div>
  </div>
</div>
